<template>
  <!-- eslint-disable max-len -->
  <div class="c-rating__success">
    <h3 class="h3 c-rate-success__title">Thank you for sharing.</h3>
    <p v-if="hasGoodScore" class="c-rate-success__description">We appreciate your feedback and so does {{ sitterFirstName }}!</p>
    <p v-else class="c-rate-success__description">
      We take your feedback seriously. We are commited to providing you with a great experience and your input assists us in
      improving our services.
    </p>

    <Button size="large" value="Go to my Sittercity" href="/account/seekers/dashboard" />
  </div>
  <!-- eslint-enable max-len -->
</template>

<script lang="ts">
import Button from '@/components/button/Button.vue';

const scores = {
  FIVE_STARS: 5,
  FOUR_STARS: 4,
  THREE_STARS: 3,
  TWO_STARS: 2,
  ONE_STAR: 1,
};

export default {
  name: 'SitterRatingSuccess',
  components: { Button },
  props: {
    sitter: {
      type: Object,
      required: true,
    },
    ratingScore: {
      type: String,
      required: true,
    },
  },
  computed: {
    sitterFirstName(): string {
      return this.sitter.name.slice(0, -3);
    },
    score(): number {
      return scores[this.ratingScore];
    },
    hasGoodScore(): boolean {
      return this.score > 3;
    },
  },
  mounted() {
    if (document.body && document.documentElement) {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }
  },
};
</script>
